import React from 'react';
import './RightPanelFooter.scss';

export interface RightPanelFooterProps {
  onRun?: () => void;
  runButtonText?: string;
}

const RightPanelFooter: React.FC<RightPanelFooterProps> = ({ onRun, runButtonText = 'Run' }) => {
  return (
    <div className="right-panel-footer">
      <button className="right-panel-footer__run-button" onClick={onRun}>
        {runButtonText}
      </button>
    </div>
  );
};

export default RightPanelFooter;
